import React from 'react';
import PropTypes from 'prop-types';
import MedicalSection from './MedicalSection';

const CollapsedSection = ({ title }) => {
  return (
    <MedicalSection
      title={title}
      expanded={false}
      onChange={() => {}}
      onAdd={() => {}}
    />
  );
};

CollapsedSection.propTypes = {
  title: PropTypes.string
};

export default CollapsedSection;